import StatusColorful from "../../../Components/Table/Components/StatusColorful";

function formatValue(value, type) {
  const hasValue = value !== null && value !== undefined && value !== "";
  if (hasValue === null || hasValue === undefined ) return "-";

  return type === "percent"
    ? `${Number(value).toFixed(2)} %`
    : `${Number(value)} روز`;
}

export default function MissionsGridCard({
  title,
  current,
  goal,
  status,
  type,
}) {
  let SVGName, text, color;

  switch (status) {
    case "passed":
      SVGName = "tick";
      text = "تکمیل شده";
      color = "blue";
      break;
    case "stable":
      SVGName = "stall";
      text = "پایدار";
      color = "green";
      break;
    case "danger":
      SVGName = "danger";
      text = "ناپایدار";
      color = "yellow";
      break;
    case "failed":
      SVGName = "failed";
      text = "رد شده";
      color = "red";
      break;
    default:
      break;
  }

  return (
    <article className="w-full rounded-2xl p-2.5 flex flex-col gap-5 bg-gradient-to-br from-white/10 to-white/5 border border-white/10">
      <div className="w-full flex items-center justify-between gap-5">
        <h5 className="text-sm text-zi-text-light dark:text-zi-text-dark whitespace-nowrap flex-1 min-w-0 overflow-x-auto">
          {title}
        </h5>
        <StatusColorful
          SVGName={SVGName}
          text={text}
          className="w-fit"
          color={color}
          containerClassName="!w-fit"
        />
      </div>
      <div className="w-full flex items-center justify-between gap-5">
        <div className="flex flex-col gap-0 items-start">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            وضعیت فعلی
          </span>
          <span
            className={`text-sm text-zi-text-light/75 dark:text-zi-text-dark/75 ${type === "days" ? "[direction:rtl]" : "[direction:ltr]"}`}
          >
            {formatValue(current, type)}
          </span>
        </div>
        <div className="flex flex-col gap-0 items-end">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            معیار
          </span>
          <span
            className={`text-sm text-zi-text-light/75 dark:text-zi-text-dark/75 ${type === "days" ? "[direction:rtl]" : "[direction:ltr]"}`}
          >
            {formatValue(goal, type)}
          </span>
        </div>
      </div>
    </article>
  );
}
